import { Logo } from "./Logo";

const links = [
  { href: "#chi-sono", label: "Chi Sono" },
  { href: "#come-funziona", label: "Come Funziona" },
  { href: "#pacchetti", label: "Pacchetti", testid: "nav-pricing-link" },
  { href: "#faq", label: "FAQ" },
  { href: "/voucher", label: "Area Voucher", testid: "nav-credits-link" },
];

export const Navbar = () => (
  <header className="sticky top-4 z-50 max-w-6xl mx-auto px-4">
    <nav className="px-6 py-3 rounded-full backdrop-blur-xl bg-white/90 border border-moss/10 shadow-[0_8px_30px_rgba(27,59,43,0.08)] flex items-center justify-between">
      <Logo />
      <div className="hidden md:flex items-center gap-7">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={l.testid}
            className="text-sm font-medium text-sub hover:text-moss transition-colors duration-200"
          >
            {l.label}
          </a>
        ))}
      </div>
      <a
        href="#pacchetti"
        data-testid="nav-contact-button"
        className="rounded-full bg-terracotta px-5 py-2.5 text-sm font-semibold text-alabaster transition-all duration-200 hover:bg-terrahover hover:-translate-y-0.5"
      >
        Riserva Consulenza
      </a>
    </nav>
  </header>
);
